import React from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../../services/translation/TranslationService";
import Svg from "../../../components/svg/Svg";
import { logoEsicBackground } from "../../../components/svg/svgImageList";

export default observer(function DisplayHeadline() {
  return (
    <div className="landing-page-title">
      <div className="welcome-to-container">
        <span className="welcome-to">{translationService.translate("LandingPage.welcome-to")}</span>
        <Svg svg={logoEsicBackground.light} />
      </div>
    </div>
  );
});
